import type { SVGProps } from 'react'
const SvgSyDoneAllRound = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width={24} height={24} {...props}>
		<path d="m254.2 449 140.9 112.7c4.9 3.9 10.3 6.8 15.9 8.8 5.6 1.9 11.5 2.9 17.4 2.9s15.4-1.7 22.5-4.9c7.1-3.3 13.6-8.2 18.8-14.6l279.1-341.2c7-8.5 5.7-21.1-2.8-28.1s-21.1-5.7-28.1 2.8L438.8 528.5c-1.4 1.7-2.9 2.8-4.7 3.7q-2.7 1.2-5.7 1.2c-3 0-2.9-.2-4.3-.7s-2.7-1.2-4-2.2L279.2 417.8c-8.6-6.9-21.2-5.5-28.1 3.1s-5.5 21.2 3.1 28.1" />
		<path
			fillOpacity={0.24}
			d="M66.7 446.7c-6.1 0-12.1 2.8-16 8-6.6 8.8-4.8 21.4 4 28l107.8 80.8c9.6 7.2 20.8 10.7 32 10.7s30.8-6.7 41.3-19.6l32-39.1-30.7-25.6-32.3 39.4c-2.6 3.2-6.5 4.9-10.3 4.9s-5.6-.9-8-2.7L78.7 450.7c-3.6-2.7-7.8-4-12-4M500 180c-5.8 0-11.5 2.5-15.5 7.3L321.4 386.6l30.7 25.6 163.3-199.6c7-8.5 5.7-21.1-2.8-28.1-3.7-3-8.2-4.5-12.7-4.5"
		/>
	</svg>
)
export default SvgSyDoneAllRound
